<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:'user',
    data(){
        return{

        }
    }
}
</script> 
<style scope lang="scss">
    
</style>